export default __webpack_public_path__ + "static/media/padel-green.bf6352b1.png";